import { ADAPTIVE_QUESTIONNAIRE_PROFILE } from '../constants';

export const isQnrAdaptive = (qnr: fhir4.Questionnaire): boolean =>
  (qnr.meta.profile ?? []).includes(ADAPTIVE_QUESTIONNAIRE_PROFILE);
